<template>
    <div class="mobile_total" @click.prevent="toggleTotal" v-if="getTotalPrice">
        <div id="title">
            <h4 v-if="!detailsOpen">
                Total: {{ getCurrency.symbol }}{{ getTotalPrice }}
            </h4>
            <h4 v-if="detailsOpen">Holiday Breakdown</h4>

            <svg
                v-if="!detailsOpen"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-if="detailsOpen"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div id="details" v-if="detailsOpen">
            <table border="0" class="table">
                <tbody>
                    <!-- 
                     -->
                    <tr>
                        <td colspan="2" align="center">
                            {{ $t("Dates") }}:
                            <strong> {{ getBookingDates }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $t("Accommodation") }}
                            <span v-if="getBookingDetails.accommodation"
                                >({{ getBookingDetails.accommodation }})</span
                            >
                        </td>
                        <td class="td-right">
                            {{ getCurrency.symbol
                            }}{{ getBookingDetails.accommodationPrice }}
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t("Hire items") }}</td>
                        <td class="td-right">
                            {{ getCurrency.symbol
                            }}{{ getBookingDetails.hire_items_price }}
                        </td>
                    </tr>
                    <tr v-if="getTransportDiscount != 0">
                        <td>{{ $t("Transport Discounts") }}</td>
                        <td class="td-right">{{ getTransportDiscount }}</td>
                    </tr>

                    <tr>
                        <td>{{ $t("Savings and Discounts") }}</td>
                        <td class="td-right">{{ $t("TBC") }}</td>
                    </tr>

                    <tr>
                        <td class="td-right bwhite">
                            <strong>{{ $t("Total") }}</strong>
                        </td>
                        <td class="td-right bwhite">
                            <strong
                                >{{ getCurrency.symbol }}{{ getTotalPrice }}
                            </strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <CurrencySwitch></CurrencySwitch>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencySwitch from "./CurrencySwitch";
export default {
    components: {
        CurrencySwitch
    },
    data() {
        return {
            detailsOpen: false
        };
    },
    computed: {
        ...mapGetters(["getBookingDetails", "getCurrency"]),
        getTotalPrice() {
            return (
                parseInt(this.getBookingDetails.transport_discount) +
                parseInt(this.getBookingDetails.hire_items_price) +
                parseInt(this.getBookingDetails.accommodationPrice)
            );
        },
        getTransportDiscount() {
            let value = this.getBookingDetails.transport_discount;
            return value == 0
                ? 0
                : "-" + this.getCurrency.symbol + Math.abs(value);
        },
        getBookingDates() {
            const d1 = this.getBookingDetails.BookedArrivalDate;
            const d2 = this.getBookingDetails.BookedDeptDate;
            if (d1 !== null && d2 !== null) {
                return this.ISO2Uk(d1) + " - " + this.ISO2Uk(d2);
            } else {
                return "";
            }
        }
    },
    methods: {
        ISO2Uk(d) {
            return (
                d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0]
            );
        },
        toggleTotal() {
            this.detailsOpen = !this.detailsOpen;
        }
    }
};
</script>

<style scoped>
#title h4 {
    margin-right: 10px;
}
table,
.bwhite {
    border-top: 1px solid white;
}
.td-right {
    text-align: right;
}
#title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mobile_total {
    position: fixed;
    top: 72px;
    right: 0px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px;
    z-index: 1000;
}
.mobile_total tbody tr:nth-child(2n) {
    background-color: rgba(0, 0, 0, 0.2);
}
@media (min-width: 1024px) {
    .mobile_total {
        display: none;
    }
}
.w-6 {
    width: 20px;
}
</style>
